import { render, staticRenderFns } from "./BankPayout.vue?vue&type=template&id=a19fe398&"
import script from "./BankPayout.vue?vue&type=script&lang=ts&"
export * from "./BankPayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports